// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"9ee62da2","409":"c17c8b57","463":"89a39c92","499":"49f7ef0b","522":"aa4c4c2f","592":"22c43262","611":"372eae5b","647":"3fc72efc","659":"4648e028","722":"a8c41c71","921":"795ad100"}[chunkId] + ".chunk.js";
};